module.exports = __webpack_public_path__ + "media/images/facebook-9a032911907b79b454791d23eaa90e0f.png";